module.exports = __webpack_public_path__ + "static/media/scatter.4a1c65c4.PNG";